import { localStorageTokenKey } from '../entities/Authentication/Authentication'

export const hasStoredApiToken = (): boolean => !! (
    localStorage.getItem(localStorageTokenKey) || sessionStorage.getItem(localStorageTokenKey)
)
